
import cx from 'classnames';

import { AnyElement, PropsOf } from '@/utils/types';

// TS
type ContentType = 'start' | 'center' | 'end';

type ColumnsProps<C extends AnyElement> = {
  as?: C;
  children?: React.ReactNode;
  alignItems?: ContentType;
  justifyContent?: ContentType;
  className?: string;
  useNegativeMargin?: boolean;
} & PropsOf<C>;

// Classes helpers
const alignClass = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
} as const;

const justifyClass = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
} as const;

// Columns
const Columns = <T extends AnyElement>({
  as: Tag,
  children,
  alignItems,
  justifyContent,
  className,
  useNegativeMargin = true,
  ...rest
}: ColumnsProps<T>) => {
  const ColumnsTag = (Tag || 'div') as React.ElementType;
  const classNames = cx('flex flex-wrap flex-row', className, {
    [alignClass[alignItems as ContentType]]: alignItems,
    [justifyClass[justifyContent as ContentType]]: justifyContent,
    '-mx-2': useNegativeMargin,
  });

  return (
    <ColumnsTag className={classNames} {...rest}>
      {children}
    </ColumnsTag>
  );
};

export default Columns;
